(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.directive('emailLink', ['EmailService', EmailLinkFn]);

    /* email link directive */
    function EmailLinkFn(EmailService) {
        var directive = {
            link: link,
            restrict: 'A',
            scope: {
                contactInfo: '@'
            }
        };
        return directive;

        function link(scope, element) {
            activate();

            // open modal for quick sending email
            function email() {
                // modal 
                EmailService.writeTo(scope.contactInfo);
            } // email

            // activate directive
            function activate() {
                // contactInfo is email 
                if (scope.contactInfo !== null && scope.contactInfo !== "" && scope.contactInfo.indexOf("@") !== -1) {
                    element.on('click', function (event) {
                        // send email
                        email();
                    });
                } // if                
            } // activate

            // on destroy
            scope.$on("$destroy", function () {
                element.off("click");
            });


        } // link
    }
})();